import React, { forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import * as rsuite from 'rsuite';
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';


const Auto_ProductRef = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);
    const [Type, setType] = React.useState(0);
    const on_Select = (event) => {
        console.dir(event)
        props.onSelect(event)
    }

    const on_Change = (event) => {
        console.dir(event)
        props.onChange(event)
    }
    useImperativeHandle(ref, () => ({
        Bind(type, ParentId = -1, GroupId = -1, title, RefId) {
            setType(type);
            if (type == 0) {

                var RequestOptions = {
                    data: {
                        'Title': title,
                        'ProductGroupId': -1,
                        'ProductGroupParentId': -1,
                    },
                    url: General.ApiRoute() + "/Product/SearchByGroup",
                    method: "post",
                    withCredentials: true,

                    headers: {
                        'ApiKey': General.APIKey(),
                        'Content-Type': 'application/json'
                    }
                }


                trackPromise(
                    axios(RequestOptions)
                        .then(result => {
                            var tmp = []
                            for (var i = 0; i < result.data.length; i++) {
                                tmp.push({
                                    Row: i + 1,
                                    value: result.data[i].id + "|" + result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle + " (" + result.data[i].identityNo + ")",
                                    lable: result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle + " (" + result.data[i].identityNo + ")",


                                })
                            }
                            setList(tmp)

                        })
                        .catch((error) => {
                            console.dir(error)
                        })
                )

            }
            else if (type == 1) // BuyFactor
                setList([]);
            else if (type == 2) // TransferBetweenStore
                setList([]);
            else if (type == 3) // ReturnFromSale
                var RequestOptions = {
                    data: {
                        'Title': title,
                        'ProductGroupId': -1,
                        'ProductGroupParentId': -1,
                    },
                    url: General.ApiRoute() + "/Product/SearchByGroup",
                    method: "post",
                    withCredentials: true,

                    headers: {
                        'ApiKey': General.APIKey(),
                        'Content-Type': 'application/json'
                    }
                }


            trackPromise(
                axios(RequestOptions)
                    .then(result => {
                        var tmp = []
                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                value: result.data[i].id + "|" + result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle + " (" + result.data[i].identityNo + ")",
                                lable: result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle + " (" + result.data[i].identityNo + ")",


                            })
                        }
                        setList(tmp)

                    })
                    .catch((error) => {
                        console.dir(error)
                    })
            )

        },
        BindByStoreId(StoreId, title) {

            var RequestOptions = {
                data: {
                    'StoreRoomId': StoreId, 'Product': title
                },
                url: General.ApiRoute() + "/Product/SearchByStoreId",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }


            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        var tmp = []
                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                value: result.data[i].id + "|" + result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle + " (" + result.data[i].identityNo + ")|" + result.data[i].saleCount + "|" + result.data[i].lastBuyPrice + "|" + result.data[i].lastPrice,
                                lable: result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle + " (" + result.data[i].identityNo + ")",


                            })
                        }
                        setList(tmp)
                    }).catch((error) => {
                        // toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )



        }
    }),
        [props.value])

    return (
        <rsuite.AutoComplete style={{ position: "relative" }}
            data={List.map((product) => ({
                label: `${product.lable}`,
                value: `${product.value}`,
            }))}
            value={props.value}
            key={props.key}
            // label={props.lable}
            // filterBy={(item, input)=> item?.label?.includes(input)}
            filterBy={(item, input) => {
                const normalizeText = (Text) => {
                    if (typeof (Text) == "string")
                        return Text.replace(/\u200c/g, '').toLowerCase();
                    else
                        return "";
                }
                return normalizeText(item?.label).includes(normalizeText(input || ""));
            }}
            renderMenuItem={(label, item) => <span>{item?.label}</span>}
            renderValue={(value, item) => (item ? item.label : "")}
            onChange={on_Change}
            onSelect={on_Select}
            placeholder='محصول'
            virtualized={false}
            width={250}
        />

    )
});

export default Auto_ProductRef;